import InfoSVG from '../../assets/svg/info.svg';
export default InfoSVG;
